module.exports = __webpack_public_path__ + "static/images/form_bg.e6c3932.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newPromotionImg/form_bg.png
// module id = heNU
// module chunks = 11